import React from 'react';

// 学生の状態バッジ【2026-09-17】
//   以前は「未登録」「名簿外」と出していたが、「未登録」が
//   「名簿に登録されていない」のか「アプリのアカウントが無い」のか区別できなかった。
//   2つは原因も対処も違うので、言葉ではっきり分ける。
//
//   アカウント未作成 … 名簿には載っているが、本人がまだアプリに登録していない（仮アカウント）
//                      → 本人にアプリを入れて登録してもらう
//   名簿未登録       … 打刻はあるが、この授業の履修者名簿に載っていない
//                      → 名簿を取り込む／履修者に追加する
export const STATUS = {
  noAccount: {
    label: 'アカウント未作成',
    title: '名簿には載っているが、本人がまだアプリに登録していない学生（仮アカウント）。本人が登録すると自動で引き継がれます',
    color: '#b91c5c',
  },
  notOnRoster: {
    label: '名簿未登録',
    title: '打刻はあるが、履修者名簿に載っていない学生。名簿を取り込むか、履修者に追加すると外れます',
    color: '#92400e',
  },
};

export function StatusBadge({ kind, size = 'sm' }) {
  const s = STATUS[kind];
  if (!s) return null;
  return (
    <span title={s.title}
          style={{
            marginLeft: '0.35rem',
            fontSize: size === 'xs' ? '0.66rem' : '0.7rem',
            color: s.color,
            border: `1px solid ${s.color}`,
            borderRadius: 4,
            padding: '0 4px',
            whiteSpace: 'nowrap',
          }}>
      {s.label}
    </span>
  );
}

/** 学生1人ぶんのバッジ。placeholder = 仮アカウント、outside = 名簿に無い */
export default function StudentStatusBadges({ placeholder, outside, size }) {
  return (
    <>
      {outside && <StatusBadge kind="notOnRoster" size={size} />}
      {placeholder && <StatusBadge kind="noAccount" size={size} />}
    </>
  );
}
